import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SignatureSignatoryAssignmentStatusEnum, signatoryAssignmentStatusTextMap } from '../../models/signature-request.dict';

@Component({
  selector: 'signature-signatory-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './signature-signatory-status-badge.component.html',
  styleUrl: './signature-signatory-status-badge.component.scss'
})
export class SignatureSignatoryStatusBadgeComponent implements OnInit, OnChanges {
  ngOnChanges(): void {
    this.updateStatusText();
  }
  @Input() status: SignatureSignatoryAssignmentStatusEnum | undefined;

  public statusText: string = '';

  ngOnInit(): void {
    this.updateStatusText();
  }

  private updateStatusText(): void {
    if (this.status !== undefined) {
      this.statusText = signatoryAssignmentStatusTextMap[this.status];
    } else {
      this.statusText = '';
    }
  }

}
